import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from '@/locales';
import { useTracking } from '@/hooks/useTracking';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { ERoutes } from '@/types/routes';
import {
  StyledHeader,
  StyledPermittedToolbar,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import { StyledAssistantButton } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/DocumentationHeader/DocumentationHeader.styled';

export const DocumentationHeaderPermitted = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { trackEvent } = useTracking();
  const { isDesktop } = useBreakpointsCtx();

  const isOnAssistant = pathname.replace(/\/$/, '') === ERoutes.DOCUMENTATION;

  const handleAssistantClick = () => {
    trackEvent('Documentation header - open assistant', { fromPath: pathname });
    navigate(ERoutes.DOCUMENTATION);
  };

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledPermittedToolbar>
        <StyledAgioH1
          noWrap
          color="customSecondary.primary.DEFAULT"
          data-testid="documentation-header-title"
        >
          {t('documentation.header.title')}
        </StyledAgioH1>

        {!isOnAssistant && (
          <div>
            <StyledAssistantButton
              variant="outlined"
              color="tertiary"
              skipTypography
              onClick={handleAssistantClick}
              data-testid="documentation-header-assistant-button"
            >
              {t('documentation.header.assistant-btn')}
            </StyledAssistantButton>
          </div>
        )}
      </StyledPermittedToolbar>
    </StyledHeader>
  );
};
